$(function () {
  var $body = $('body');

  // only works on short course listing page
  if (!$body.hasClass('page-type--shortcourseslanding')) return;

  var api = '/umbraco/api/searchapi/filtercourses/';
  var courseListing, courseFilters;
  var $searchForm = $('#search-form');
  console.log('$searchForm', $searchForm);

  // list instance
  courseListing = new Vue({
    el: '.courses-listing',
    data: courses, // from the initial load data
    created: function () {
      this.keyword = '';
      this.selMonth = '';
      this.selArea = '';
      this.selCampus = '';
      this.months = ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      this.showing = this.getShowing(courses);
    },
    methods: {
      prev: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth,
            Math.max(1, this.pageNumber - 1));
      },

      next: function () {
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth,
            Math.min(this.pageNumber + 1, this.totalPages));
      },

      clear: function (type) {
        if (type === 'query') this.keyword = '';
        if (type === 'month') this.selMonth = '';
        if (type === 'area') {
          courseFilters.selectedArea = courseFilters.areas[0];
          this.selArea = '';
        }
        if (type === 'campus') {
          courseFilters.selectedCampus = courseFilters.campuses[0];
          this.selCampus = '';
        }

        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth, 1);
      },

      reset: function () {
        courseFilters.fetchOnUpdate = false; // disable fetch-on-update for a moment
        courseFilters.selectedCampus = courseFilters.campuses[0];
        courseFilters.selectedArea = courseFilters.areas[0];
        courseFilters.fetchOnUpdate = true;

        this.keyword = '';
        this.selMonth = '';
        this.selArea = '';
        this.selCampus = '';

        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth, 1);
      },

      ga: function () {
        gtag && gtag('event', 'Select a course', {
          event_category: 'Course Landing',
          transport_type: 'beacon'
        });
      },

      getShowing: function(data) {
        console.log('getShowing', data.totalPages);
        var retShowing = '';

        if (data.totalItems === 0) retShowing = '';
        else if (data.totalItems === 1) retShowing = "Showing 1 short course";
        else if (data.totalPages === 1) retShowing = "Showing " + data.totalItems + " short courses";
        else {
          var from = (data.pageNumber * data.pageSize) - data.pageSize + 1;
          var to = data.pageNumber * data.pageSize;
          if (to > data.totalItems) to = data.totalItems;
          retShowing = "Showing " + from + "-" + to + " of " + data.totalItems + " short courses";
        }

        return retShowing;
      },

      fetch: function (campus, area, query, month, page) {
        var vm = this;

        if (courseFilters.selectedArea.value) vm.selArea = courseFilters.selectedArea.label;
        else vm.selArea = '';

        if (courseFilters.selectedCampus.value) vm.selCampus = courseFilters.selectedCampus.label;
        else vm.selCampus = '';

        $.getJSON(api, {
          umbracopageId: currentPage, // from initial load // 1110, // 
          page: page || 1,
          query: query || '',
          month: month || '',
          campus: campus,
          studyAreaId: area,
          courseType: 'Short Course'
        }, function (data) {
          vm.pageSize = data.pageSize;
          vm.pageNumber = data.pageNumber;
          vm.totalItems = data.totalItems;
          vm.totalPages = data.totalPages;
          vm.items = data.items;

          vm.showing = vm.getShowing(data);
        })
      },

      searchQuery: function (evt) {
        evt.preventDefault();
        this.keyword = $(evt.target).find('.course-search__query').val().trim();
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth, 1);
      },

      searchMonth: function (selMonth) {
        this.selMonth = selMonth;
        this.fetch(courseFilters.selectedCampus.value, courseFilters.selectedArea.value, this.keyword, this.selMonth, 1);
      },

      freeModal: function (event) {
        event.preventDefault();
        openFeeFreeModal();
      }
    }
  });

  // filter instance
  courseFilters = new Vue({
    el: '.filters--courses-listing',
    data: function () {
      var pageStudyAreas = [
        {label: 'All Study Areas', value: null}
      ];
      Object.keys(studyAreas).forEach((key) => {
        console.log('studyArea', studyAreas[key]);
        pageStudyAreas.push({label: studyAreas[key], value: key});
      });

      var data = {
        campuses: LOCATIONS,
        areas: pageStudyAreas,
        fetchOnUpdate: true
      };

      data.selectedCampus = data.campuses[0];
      data.selectedArea = data.areas[0];
      return data;
    },
    created: function () {

    },
    computed: {
      selectedCampusLabel: function () {
        if (this.selectedCampus === null)
          return 'Any Campus';

        return this.selectedCampus.label;
      },
      selectedAreaLabel: function () {
        if (this.selectedArea === null)
          return 'All Study Areas';

        return this.selectedArea;
      },
    },
    watch: {
      selectedCampus: function (newCampus) {
        if (this.fetchOnUpdate)
          courseListing.fetch(newCampus.value, this.selectedArea.value, courseListing.keyword, courseListing.selMonth)
      },
      selectedArea: function (newArea) {
        if (this.fetchOnUpdate)
          courseListing.fetch(this.selectedCampus.value, newArea.value, courseListing.keyword, courseListing.selMonth)
      }
    },
    methods: {
      selectCampus: function (evt, campus) {
        this.toggleDropdown(evt, false);
        this.selectedCampus = campus;
      },

      isCampusSelected: function (campus) {
        return this.selectedCampus === campus;
      },

      isAreaSelected: function (area) {
        return this.selectedArea === area;
      },

      selectArea: function (evt, area) {
        this.toggleDropdown(evt, false);
        this.selectedArea = area;
      },

      toggleDropdown: function (evt, flag) {
        var $filter = $(evt.target).parents('.filter');
        $filter.toggleClass('open', flag);
      },
    }
  });
});
